import React from 'react';
import { Link, useLocation } from 'react-router-dom';
import { useTranslation } from 'react-i18next';
import './DemoSection.css';
import { convertFromMKD, getCurrencySymbol, isCurrencyPrefix } from '../../../utils/currency';

const DemoSection = () => {
  const { t } = useTranslation();
  const location = useLocation();
  const currentLang = location.pathname.split('/')[1] || 'mk';

  const languages = [
    { code: 'mk', name: 'Македонски', icon: 'https://flagcdn.com/mk.svg' },
    { code: 'al', name: 'Shqip', icon: 'https://flagcdn.com/al.svg' },
    { code: 'rs', name: 'Српски', icon: 'https://flagcdn.com/rs.svg' },
    { code: 'hr', name: 'Hrvatski', icon: 'https://flagcdn.com/hr.svg' },
    { code: 'tr', name: 'Türkçe', icon: 'https://flagcdn.com/tr.svg' },
    { code: 'de', name: 'Deutsch', icon: 'https://flagcdn.com/de.svg' },
    { code: 'en', name: 'English', icon: 'https://flagcdn.com/gb.svg' }
  ];

  return (
    <section className="demo-section">
      <div className="demo-container">
        <div className="section-header">
          <div className="section-divider">
            <div className="divider-line"></div>
            <span className="divider-text">{t('demo.badge', 'Глобална Платформа')}</span>
            <div className="divider-line"></div>
          </div>
          <h2 className="section-title">
            {t('demo.title', 'Спомен.мк за Сите')}
          </h2>
          <p className="section-description">
            {t('demo.description', 'Создадена за да ги сочувствуваме различностите и да ги почитуваме спомените на сите луѓе, без разлика на јазикот, културата или верата.')}
          </p>
        </div>

        <div className="demo-content">
          <div className="feature-showcase">
            <div className="showcase-card multilingual-card">
              <div className="card-header">
                <div className="card-icon">🌐</div>
                <h3 className="card-title">
                  {t('demo.multilingual.title', 'Повеќејазична Поддршка')}
                </h3>
              </div>
              <p className="card-description">
                {t('demo.multilingual.description', 'Нашата платформа поддржува повеќе јазици за да биде достапна за сите луѓе.')}
              </p>
              <div className="languages-showcase">
                {languages.map(lang => (
                  <div key={lang.code} className="language-card">
                    <div className="flag-container">
                      <img src={lang.icon} alt={lang.name} className="flag-icon" />
                    </div>
                    <span className="language-name">{lang.name}</span>
                  </div>
                ))}
              </div>
            </div>

            <div className="showcase-card equality-card">
              <div className="card-header">
                <div className="card-icon">⚖️</div>
                <h3 className="card-title">
                  {t('demo.equality.title', 'Еднаквост за Сите')}
                </h3>
              </div>
              <p className="card-description">
                {t('demo.equality.description', 'Секој заслужува достоинствен и рамноправен третман при чување на спомените.')}
              </p>
              <div className="equality-visual">
                <div className="equality-icons">
                  <div className="equality-icon">👥</div>
                  <div className="equality-icon">🤝</div>
                  <div className="equality-icon">💝</div>
                </div>
                <p className="equality-text">
                  {t('demo.equality.subtitle', 'Почит • Достоинство • Споделена љубов')}
                </p>
              </div>
            </div>

            <div className="showcase-card pricing-card">
              <div className="card-header">
                <div className="card-icon">💰</div>
                <h3 className="card-title">
                  {t('demo.pricing.title', 'Достапни Цени')}
                </h3>
              </div>
              <p className="card-description">
                {t('demo.pricing.description', 'Квалитетни услуги на достапни цени за сите семејства.')}
              </p>
              <div className="pricing-highlight">
                <div className="price-tag">
                  {isCurrencyPrefix(currentLang) ? (
                    <>
                      <span className="price-currency">{getCurrencySymbol(currentLang)}</span>
                      <span className="price-amount">{convertFromMKD(1990, currentLang)}</span>
                    </>
                  ) : (
                    <>
                      <span className="price-amount">1990</span>
                      <span className="price-currency">МКД</span>
                    </>
                  )}
                </div>
                <p className="price-description">
                  {t('demo.pricing.lifetime', 'Доживотна употреба')}
                </p>
              </div>
            </div>
          </div>

          <div className="cta-section">
            <div className="cta-content">
              <h3 className="cta-title">
                {t('demo.cta.title', 'Започнете Денес')}
              </h3>
              <p className="cta-description">
                {t('demo.cta.description', 'Создадете прекрасен споменик за вашите сакани и споделете ги нивните приказни со светот.')}
              </p>
              <div className="cta-buttons">
                <Link to={`/${currentLang}/create-profile`} className="cta-button primary">
                  <span className="button-icon">💝</span>
                  {t('demo.cta.createProfile', 'Создади Профил')}
                </Link>
                <Link to={`/${currentLang}/products`} className="cta-button secondary">
                  <span className="button-icon">🛒</span>
                  {t('demo.cta.orderPlate', 'Нарачајте QR паметна плочка за споменик')}
                </Link>
                <Link to={`/${currentLang}/faq`} className="cta-button secondary">
                  <span className="button-icon">❓</span>
                  {t('demo.cta.faq', 'FAQ')}
                </Link>
              </div>
            </div>
          </div>
        </div>
      </div>
    </section>
  );
};

export default DemoSection;
